var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{staticClass:"max-container"},[_c('CustomMenu',{attrs:{"Itemselected":1}}),_c('v-btn',{staticClass:"mb-2",attrs:{"color":"primary"},on:{"click":function($event){return _vm.openDialog()}}},[_vm._v(" Crear Estudiante + ")]),_c('CreateStudent'),_c('ListStudents')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }